export const QA_NAME_CALENDAR_RAIL_BLOCK_WARNING = 'calendarRailBlockWarning'
